import React from "react";

interface DogHomePageIconProps {
  fill?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const DogHomePageIcon: React.FC<DogHomePageIconProps> = ({
  fill = "currentColor",
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 102.000000 87.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g
        transform="translate(0.000000,87.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M358 845 c-47 -18 -114 -63 -153 -105 -16 -17 -58 -54 -93 -82 -108
-86 -129 -170 -73 -288 l30 -62 10 38 c5 22 12 48 14 59 3 11 5 -7 6 -41 1
-49 5 -64 24 -82 23 -22 47 -29 47 -14 1 4 7 30 15 57 13 49 14 49 14 14 1
-20 -6 -53 -14 -73 -13 -31 -13 -40 -1 -70 16 -39 48 -63 92 -71 37 -7 73 12
101 54 28 41 31 122 8 197 -27 87 -55 274 -49 318 12 75 24 73 18 -4 -5 -61
-1 -93 21 -175 50 -191 78 -285 85 -285 4 0 10 18 13 40 7 51 38 94 91 125 23
13 51 35 62 47 23 27 94 142 94 154 0 4 -9 17 -19 28 -22 24 -85 160 -70 151
5 -4 20 -27 33 -53 13 -26 35 -57 48 -69 25 -23 102 -47 188 -59 l55 -7 -40
-12 c-33 -10 -41 -17 -43 -39 -2 -18 4 -36 18 -51 41 -44 4 -84 -90 -100 -41
-7 -43 -9 -23 -18 17 -7 34 -6 63 6 54 21 51 4 -6 -29 -37 -22 -53 -26 -90
-21 -25 2 -51 10 -57 17 -9 9 -1 10 38 6 l50 -6 -65 20 c-36 10 -76 19 -89 20
-30 0 -88 -35 -102 -62 l-11 -21 28 20 c49 34 60 37 38 12 -12 -13 -30 -37
-40 -54 l-18 -30 33 30 32 30 -20 -45 c-11 -25 -20 -58 -20 -75 1 -28 2 -27
21 18 11 26 24 47 29 47 5 0 9 -20 9 -43 0 -46 26 -134 55 -183 l16 -29 -6 30
c-31 142 -36 175 -30 211 3 23 12 49 19 59 11 16 18 16 46 7 56 -20 102 -14
152 17 26 16 52 39 58 50 6 12 17 21 24 21 24 0 44 35 56 98 18 101 12 108
-133 136 -42 9 -88 23 -102 32 -14 9 -44 47 -65 84 -33 56 -49 72 -87 91 -59
29 -187 37 -245 14z m236 -148 c12 -9 17 -23 14 -42 -3 -26 -7 -30 -33 -30
-25 0 -30 4 -30 25 0 21 5 25 27 25 14 -1 24 3 22 7 -10 17 -51 7 -74 -17 -13
-14 -28 -25 -34 -25 -16 1 61 70 77 70 7 0 21 -6 31 -13z m-259 -158 c8 -29
12 -55 10 -57 -2 -2 -9 16 -15 39 -6 24 -14 53 -17 64 -3 11 -2 17 1 14 4 -4
14 -31 21 -60z m607 -111 c-9 -9 -12 -7 -12 12 0 19 3 21 12 12 9 -9 9 -15 0
-24z"
        />
        <path d="M557 663 c-14 -13 -6 -23 18 -23 28 0 34 15 9 24 -19 7 -19 7 -27 -1z" />
      </g>
    </svg>
  );
};

export default DogHomePageIcon;
